import { CategoryChartQueryParam } from "../categoryChart";
import { TableKpiProviders } from "./categoryChartData.types";
import { getTable } from "./fetchProviderTableData";
import _ from "lodash";

export const fetchProvidersComparisonTableData = async ({
    fetchParams,
    metadata,
    categoryChart,
    providers,
    kpis,
    category,
    locationAdminIds,
    latestYear
}: CategoryChartQueryParam): Promise<TableKpiProviders> => {
    const tableData = await getTable({
        metadata,
        fetchParams,
        categoryChart,
        providers,
        kpis,
        category,
        locationAdminIds,
        latestYear
    });

    // console.log(tableData);

    return {
        vis: _.flattenDeep(tableData).filter(d => d != null)
    };

    // const data = [
    //     {
    //         col1: "Hello",
    //         col2: "World",
    //         col3: "World"
    //     },
    //     {
    //         col1: "react-table",
    //         col2: "rocks",
    //         col3: "rocks"
    //     },
    //     {
    //         col1: "whatever",
    //         col2: "you want",
    //         col3: "you want"
    //     },
    //     {
    //         col1: "whatever2",
    //         col2: "you want 2",
    //         col3: "you want"
    //     }
    // ];

    // const columns = [
    //     {
    //         Header: "Column 1",
    //         accessor: "col1" // accessor is the "key" in the data
    //     },
    //     {
    //         Header: "Com 2,3",
    //         columns: [
    //             {
    //                 Header: "Column 2",
    //                 accessor: "col2"
    //             },
    //             {
    //                 Header: "Column 2",
    //                 accessor: "col3"
    //             }
    //         ]
    //     }
    // ];

    // return {
    //     vis: [
    //         {
    //             waterProvider: {
    //                 adminId: "aaaa",
    //                 name: "aaaa",
    //                 tid: 22,
    //                 residentialTariffStruct: "blank"
    //             },
    //             data: {
    //                 columns,
    //                 data,
    //                 rowClassNames: ["string", "string", "number"],
    //                 pageSize: data?.length
    //             }
    //         }
    //     ]
    // };
};
